import { useState, useEffect } from "react";
import '../common/style.css';
import './payment.css';
import { createPayment } from '../http/api';
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import { useAuth } from "../http/authcontex";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function AddPaymentForm({ formData, closeModal, updatePaymentInList, addPaymentToList, accountId }) {
    const navigate = useNavigate();
    const authContext = useAuth();

    const { userEmail } = useAuth();

    const [localFormData, setLocalFormData] = useState(formData || {
        id: 0,
        loanAccount: {
            id: accountId
        },
        invoiceNo: "",
        invoiceDate: "",
        dueDate: "",
        invoiceAmount: "",
        paymentReceived: "0", // Default value
        tdsReceived: "0",
        paymentReceivedDate: "",
        remark: "",
        submittedBy: "",
        paymentMethod: ""
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (formData) {
          setLocalFormData({
            ...formData,
            loanAccount: {
              id: formData.loanAccount?.id || accountId // Use optional chaining
            }
          });
        } else {
          setLocalFormData({
            id: 0,
            loanAccount: {
              id: accountId
            },
            invoiceNo: "",
            invoiceDate: "",
            dueDate: "",
            invoiceAmount: "",
            paymentReceived: "0", // Default value
            tdsReceived: "0",
            paymentReceivedDate: "",
            remark: "",
            submittedBy: "",
            paymentMethod: ""
          });
        }
      }, [formData, accountId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setLocalFormData({
            ...localFormData,
            [name]: value
        });

        if (errors[name]) {
            setErrors({
                ...errors,
                [name]: null
            });
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!localFormData.invoiceNo.trim()) {
            newErrors.invoiceNo = "Invoice number is required.";
        }

        if (!localFormData.invoiceDate) {
            newErrors.invoiceDate = "Invoice date is required.";
        }

        if (!localFormData.dueDate) {
            newErrors.dueDate = "Due date is required.";
        }

        if (Number(localFormData.tdsReceived)+Number(localFormData.paymentReceived)>localFormData.invoiceAmount) {
            if (Number(localFormData.tdsReceived)+Number(localFormData.paymentReceived)>localFormData.invoiceAmount) {
                newErrors.paymentReceived = "Payment Received + TDS Received cannot be greater than Invoice Amount.";
            }else {
                newErrors.tdsReceived = "Payment Received + TDS Received cannot be greater than Invoice Amount.";
            }
        } else if (!localFormData.tdsReceived){
            newErrors.tdsReceived = "TDS Amount received date is required.";
        }

        if (!localFormData.invoiceAmount) {
            newErrors.invoiceAmount = "Invoice amount is required.";
        } else if (isNaN(localFormData.invoiceAmount) || Number(localFormData.invoiceAmount) < 0) {
            newErrors.invoiceAmount = "Valid invoice amount is required.";
        }

        if (Number(localFormData.paymentReceived) > 0) {
            if (!localFormData.paymentReceivedDate) {
                newErrors.paymentReceivedDate = "Payment received date is required.";
            }
            if (!localFormData.paymentMethod) {
                newErrors.paymentMethod = "Payment method is required.";
            }
        }

        if (localFormData.invoiceDate && localFormData.dueDate) {
            const invoiceDate = new Date(localFormData.invoiceDate);
            const dueDate = new Date(localFormData.dueDate);
            if (dueDate < invoiceDate) {
                newErrors.dueDate = "Due date cannot be before invoice date.";
            }
        }

        if (Number(localFormData.paymentReceived) > Number(localFormData.invoiceAmount)) {
            newErrors.paymentReceived = "Payment received cannot exceed invoice amount.";
        }

        return newErrors;
    };

    const handleUpdate = () => {
        const newErrors = validateForm();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        const updatedFormData = { ...localFormData };
        console.log(updatedFormData)

        updatedFormData.submittedBy = userEmail
        createPayment(updatedFormData)
            .then(response => {
                if (response.status >= 200 && response.status < 300) {
                    if (localFormData.id) {
                        updatePaymentInList(updatedFormData);
                    } else {
                        addPaymentToList({
                            ...updatedFormData,
                            id: response.data.id
                        });
                    }
                    closeModal();
                    navigate('/payment', { state: { success: true } });
                } else {
                    //setToast('Unexpected response from server.', 'error');
                    toast.error('Error adding payment.');
                }
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    authContext.logout();
                    navigate("");
                } else {
                    toast.error('Error adding payment.');
                    //setToast('Error adding payment. Please try again.', 'error');
                }
            });
    };

    const paymentMethodOptions = [
        { value: '', label: 'Select Method' },
        { value: 'Card', label: 'Credit Card' },
        { value: 'Bank Transfer', label: 'Bank Transfer' },
        { value: 'Cash', label: 'Cash' },
        { value: 'Cheque', label: 'Cheque' },
        { value: 'Credit note', label: 'Credit Note' }
    ];

    const handleSelectChange = (selectedOption) => {
        handleChange({
            target: {
                name: 'paymentMethod',
                value: selectedOption ? selectedOption.value : '',
            }
        });
    };

    return (
        <div className="AddPaymentForm">
            <form className="data-table">
                <div className="mb-1">
                    <label htmlFor="invoiceNo" className="form-label form-control-sm mb-0 ps-0">Invoice Number</label>
                    <input
                        type="text"
                        className={`form-control form-control-sm ${errors.invoiceNo ? 'is-invalid' : ''}`}
                        id="invoiceNo"
                        name="invoiceNo"
                        value={localFormData.invoiceNo}
                        onChange={handleChange}
                    />
                    {errors.invoiceNo && <div className="invalid-feedback">{errors.invoiceNo}</div>}
                </div>

                <div className="mb-1">
                    <label htmlFor="invoiceDate" className="form-label form-control-sm mb-0 ps-0">Invoice Date</label>
                    <input
                        type="date"
                        className={`form-control form-control-sm ${errors.invoiceDate ? 'is-invalid' : ''}`}
                        id="invoiceDate"
                        name="invoiceDate"
                        value={localFormData.invoiceDate}
                        onChange={handleChange}
                    />
                    {errors.invoiceDate && <div className="invalid-feedback">{errors.invoiceDate}</div>}
                </div>

                <div className="mb-1">
                    <label htmlFor="dueDate" className="form-label form-control-sm mb-0 ps-0">Due Date</label>
                    <input
                        type="date"
                        className={`form-control form-control-sm ${errors.dueDate ? 'is-invalid' : ''}`}
                        id="dueDate"
                        name="dueDate"
                        value={localFormData.dueDate}
                        onChange={handleChange}
                    />
                    {errors.dueDate && <div className="invalid-feedback">{errors.dueDate}</div>}
                </div>

                <div className="mb-1">
                    <label htmlFor="invoiceAmount" className="form-label form-control-sm mb-0 ps-0">Invoice Amount</label>
                    <input
                        type="number"
                        className={`form-control form-control-sm ${errors.invoiceAmount ? 'is-invalid' : ''}`}
                        id="invoiceAmount"
                        name="invoiceAmount"
                        value={localFormData.invoiceAmount}
                        onChange={handleChange}
                        min="0"
                        step="0.01"
                    />
                    {errors.invoiceAmount && <div className="invalid-feedback">{errors.invoiceAmount}</div>}
                </div>

                {/* Payment Received Section */}
                <div className="mb-1">
                    <label htmlFor="paymentReceived" className="form-label form-control-sm mb-0 ps-0">Payment Received</label>
                    <input
                        type="number"
                        className={`form-control form-control-sm ${errors.paymentReceived ? 'is-invalid' : ''}`}
                        id="paymentReceived"
                        name="paymentReceived"
                        value={localFormData.paymentReceived}
                        onChange={handleChange}
                        min="0"
                        step="0.01"
                    />
                    {errors.paymentReceived && <div className="invalid-feedback">{errors.paymentReceived}</div>}
                </div>

                <div className="mb-1">
                    <label htmlFor="paymentReceived" className="form-label form-control-sm mb-0 ps-0">TDS Amount Received</label>
                    <input
                        type="number"
                        className={`form-control form-control-sm ${errors.tdsReceived ? 'is-invalid' : ''}`}
                        id="tdsReceived"
                        name="tdsReceived"
                        value={localFormData.tdsReceived}
                        onChange={handleChange}
                        min="0"
                        step="0.01"
                    />
                    {errors.tdsReceived && <div className="invalid-feedback">{errors.tdsReceived}</div>}
                </div>

                <div className="mb-1">
                    <label htmlFor="paymentReceivedDate" className="form-label form-control-sm mb-0 ps-0">Payment Received Date</label>
                    <input
                        type="date"
                        className={`form-control form-control-sm ${errors.paymentReceivedDate ? 'is-invalid' : ''}`}
                        id="paymentReceivedDate"
                        name="paymentReceivedDate"
                        value={localFormData.paymentReceivedDate}
                        onChange={handleChange}
                    />
                    {errors.paymentReceivedDate && <div className="invalid-feedback">{errors.paymentReceivedDate}</div>}
                </div>

                <div className="mb-1">
                    <label htmlFor="paymentMethod" className="form-label form-control-sm mb-0 ps-0">Payment Method</label>
                    <Select
                        className="form-control form-control-sm p-0"
                        options={paymentMethodOptions}
                        value={paymentMethodOptions.find(option => option.value === localFormData.paymentMethod)}
                        onChange={handleSelectChange}
                        placeholder="Select Method"
                        isSearchable
                    />
                    {errors.paymentMethod && (<div className="invalid-feedback d-block">{errors.paymentMethod}</div>)}
                    {/* {errors.paymentMethod && <div className="invalid-feedback">{errors.paymentMethod}</div>} */}
                </div>

                <div className="mb-1">
                    <label htmlFor="remark" className="form-label form-control-sm mb-0 ps-0">Remark</label>
                    <input
                        type="text"
                        className={`form-control form-control-sm ${errors.remark ? 'is-invalid' : ''}`}
                        id="remark"
                        name="remark"
                        value={localFormData.remark}
                        onChange={handleChange}
                    />
                    {errors.remark && <div className="invalid-feedback">{errors.remark}</div>}
                </div>

                <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={handleUpdate}
                >
                    {localFormData.id ? 'Update Payment' : 'Add Payment'}
                </button>
            </form>
        </div>
    );
}
